import React, { Component } from "react";

import "./styles.css";

class ItemCreatorVerdadeiroFalso extends Component {
  render() {
    return (
      <div className="verdadeiro-falso-container">
        <input
          type="radio"
          id={`true-check-item-${this.props.itemIndex}`}
          className="common-item-check"
          checked={this.props.checkStatus}
          disabled={this.props.readOnly}
          onChange={() =>
            this.props.itemCheckChanger(this.props.itemIndex, true)
          }
        />
        <label
          htmlFor={`true-check-item-${this.props.itemIndex}`}
          className={
            this.props.checkStatus
              ? "true-or-false-item-check-true item-check-true"
              : "true-or-false-item-check-true"
          }
        >
          <i className="fa fa-check"></i>
        </label>
        <input
          type="radio"
          id={`false-check-item-${this.props.itemIndex}`}
          className="common-item-check"
          checked={!this.props.checkStatus}
          disabled={this.props.readOnly}
          onChange={() =>
            this.props.itemCheckChanger(this.props.itemIndex, false)
          }
        />
        <label
          htmlFor={`false-check-item-${this.props.itemIndex}`}
          className={
            !this.props.checkStatus
              ? "true-or-false-item-check-false item-check-false"
              : "true-or-false-item-check-false"
          }
        >
          <i className="fa fa-times"></i>
        </label>
      </div>
    );
  }
}

export default ItemCreatorVerdadeiroFalso;
